/**
 * Derived from svg-path-properties@0.2.2 vendored by flubber@0.4.2 (MIT).
 * Adapted for dependency-free internal ESM use in anvil2.
 */

type Point = {
  x: number;
  y: number;
};

type SegmentProperties = {
  x: number;
  y: number;
  tangentX: number;
  tangentY: number;
};

class LinearPosition {
  readonly x0: number;

  readonly x1: number;

  readonly y0: number;

  readonly y1: number;

  constructor(x0: number, x1: number, y0: number, y1: number) {
    this.x0 = x0;
    this.x1 = x1;
    this.y0 = y0;
    this.y1 = y1;
  }

  getTotalLength() {
    return Math.sqrt((this.x0 - this.x1) ** 2 + (this.y0 - this.y1) ** 2);
  }

  getPointAtLength(pos: number): Point {
    const fraction =
      pos / Math.sqrt((this.x0 - this.x1) ** 2 + (this.y0 - this.y1) ** 2);
    const newDeltaX = (this.x1 - this.x0) * fraction;
    const newDeltaY = (this.y1 - this.y0) * fraction;

    return { x: this.x0 + newDeltaX, y: this.y0 + newDeltaY };
  }

  getTangentAtLength(): Point {
    const module = Math.sqrt(
      (this.x1 - this.x0) ** 2 + (this.y1 - this.y0) ** 2,
    );
    return { x: (this.x1 - this.x0) / module, y: (this.y1 - this.y0) / module };
  }

  getPropertiesAtLength(pos: number): SegmentProperties {
    const point = this.getPointAtLength(pos);
    const tangent = this.getTangentAtLength();

    return { x: point.x, y: point.y, tangentX: tangent.x, tangentY: tangent.y };
  }
}

export default function createLinearPosition(
  x0: number,
  x1: number,
  y0: number,
  y1: number,
) {
  return new LinearPosition(x0, x1, y0, y1);
}
